import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { SignaturePad } from 'angular2-signaturepad';
import { I18nInterface } from 'ngx-image-drawing'

@Component({
  selector: 'app-addSignature',
  templateUrl: './addSignature.component.html',
  styleUrls: ['./addSignature.component.scss']
})

export class AddSignatureComponent implements OnInit {

  fontSize = [
    { fontsize: 7 },
    { fontsize: 8 },
    { fontsize: 9 },
    { fontsize: 10 },
    { fontsize: 11 },
    { fontsize: 12 },
    { fontsize: 14 },
    { fontsize: 16 },
    { fontsize: 18 },
    { fontsize: 20 },
    { fontsize: 22 },
    { fontsize: 24 },
    { fontsize: 26 },
    { fontsize: 28 },
    { fontsize: 36 },
    { fontsize: 48 },
    { fontsize: 72 }
  ]

  family = [
    { font: 'Architects Daughter, cursive' },
    { font: 'Dancing Script, cursive' },
    { font: 'Pacifico, cursive' },
    { font: 'Satisfy, cursive' },
    { font: 'Caveat, cursive' },
    { font: 'Cookie, cursive' },
    { font: 'Great Vibes, cursive' },
    { font: 'Parisienne, cursive' },
    { font: 'Sacramento, cursive' },
    { font: 'Yellowtail, cursive' },
    { font: 'Alex Brush, cursive' },
    { font: 'Allura, cursive' },
    { font: 'Damion, cursive' },
    { font: 'Homemade Apple, cursive' },
    { font: 'Leckerli One, cursive' },
    { font: 'Mr Dafoe, cursive' },
    { font: 'Nothing You Could Do, cursive' },
    { font: 'Pinyon Script, cursive' },
    { font: 'Tangerine, cursive' },
    { font: 'Cedarville Cursive, cursive' },
    { font: 'Grand Hotel, cursive' },
    { font: 'Herr Von Muellerhoff, cursive' },
    { font: 'Italianno, cursive' },
    { font: 'Kristi, cursive' },
    { font: 'Niconne, cursive' },
    { font: 'Norican, cursive' },
    { font: 'Petit Formal Script, cursive' },
    { font: 'Rochester, cursive' },
    { font: 'Bilbo Swash Caps, cursive' },
    { font: 'Clicker Script, cursive' },
    { font: 'Dawning of a New Day, cursive' },
    { font: 'Euphoria Script, cursive' },
    { font: 'Ma Shan Zheng, cursive' },
    { font: 'Mr De Haviland, cursive' },
    { font: 'Qwigley, cursive' },
    { font: 'Sofia Script, cursive' },
    { font: 'The Girl Next Door, cursive' },
    { font: 'Zeyada, cursive' },
    { font: 'Beth Ellen, cursive' },
    { font: 'Charmonman, cursive' },
    { font: 'Devonshire, cursive' },
    { font: 'Dr Sugiyama, cursive' },
    { font: 'Engagement, cursive' },
    { font: 'League Script, cursive' },
    { font: 'Meie Script, cursive' },
    { font: 'Mr Bedfort, cursive' },
    { font: 'Romanesco, cursive' },
    { font: 'Stalemate, cursive' },
    { font: 'Zhi Mang Xing, cursive' },
  ]

  fontfamilys = [
    { font: 'Arail' },
    { font: 'Calibri' },
    { font: 'Roboto' },
    { font: 'Tahoma' },
    { font: 'Verdana' },
  ];
  link = [
    'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
    'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
    'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
    'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
    'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
  ];

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  folderId: number = 0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;

  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;

  menuModulesList: any = [] = [];
  folderID: number = 0;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  fiveSignaturesLimitReached: boolean = true;
  getAllSignatures: any = [] = [];
  signatureID: number = 0;
  signatureData: any;
  hasSignature: boolean = false;
  signOpt: string = 'draw';
  Imageurl: any;
  filenameForSign = "";
  penColor: string = "";
  signOrInitialImageObj: any[];
  signInitialFontFamily: any;
  signatureBase64: string;
  signName: string;
  SignButtonEnable: boolean = false;
  DrawButtonEnable: boolean = false;
  InitailButtonEnable: boolean = false;
  signaturePadOptions: any = {
    'minWidth': 2,
    'canvasWidth': 822,
    'canvasHeight': 150,
    'penColor': "blue"
  };
  brushColor: string = ""
  participantEmailId: string = "";
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  autoFill: boolean = false;
  public i18n: I18nInterface = {
    saveBtn: "Save as image as JPEG",
    sizes: { extra: "Extra" }
  }
  selected: any;

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddSignatureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(x => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
      this.folderID = SelectedCore[0].folderID;
    }

    SelectedContact = this.menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter(x => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }
    this.data;
    this.participantEmailId = this.data.participantEmailId;
    this.getAllSignature();
  }

  getAllSignature() {
    if (this.participantEmailId == "" || this.participantEmailId == undefined || this.participantEmailId == null) {
      // this.dialogueRef = this.dialog.open(templateRef, {
      //   panelClass: 'custom-modalboxSign'
      //  });
      return;
    }
    var rqModel = {
      email: this.participantEmailId,
    }
    this.spinner = true;
    this.loaderService.show();
    this.settingsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.getAllSignatures = this.responseHolder.data.signatures;

          if (this.getAllSignatures == null) {
            //  this.dialogueRef = this.dialog.open(templateRef, {
            //   panelClass: 'custom-modalboxSign'
            //  });
            return;
          }

          if (this.getAllSignatures.length > 0) {
            this.hasSignature = true;
            this.getAllSignatures.forEach(n => {

              n.signature = JSON.parse(n.signature);
            });
          } else {
            this.hasSignature = false;
          }


          if (this.getAllSignatures.length == 5) {
            this.fiveSignaturesLimitReached = true;
          }
          else {
            this.fiveSignaturesLimitReached = false;
          }


          // if(item.signatureBase64!='' || item.ImageData.length!=0 || item.signatureText!=''){
          //   this.dialogueRef = this.dialog.open(templateRef, {
          //     panelClass: 'custom-modalboxSign'
          //   });
          //   return;
          // } 

          var checkSignDefault = [];
          checkSignDefault = this.responseHolder.data.signatures.filter(x => x.isDefault == true);
          if (checkSignDefault.length > 0) {

            // let data:any=datas;//this.ControlData;
            this.signatureID = this.signatureID;
            let sJson = checkSignDefault[0].signature;

            if (sJson.type == 'Draw') {
              this.signatureBase64 = sJson.signatureBase64;
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = [];
            }
            if (sJson.type == 'Upload') {
              this.signatureBase64 = "";
              this.signName = "";
              this.signInitialFontFamily = "";
              this.signOrInitialImageObj = sJson.ImageData;
            }
            if (sJson.type == 'Type In') {
              this.signatureBase64 = "";
              this.signName = sJson.signatureText;
              this.signInitialFontFamily = sJson.signInitialFontFamily;
              this.signOrInitialImageObj = [];
            }
            // return;

            // if(this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
            //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
            //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
            //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
            //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
            //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
            //   var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);

            //   if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0){
            //     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
            //  }      
            // this.particiantJsonList = this.particiantJsonList;          
            // }
          } else {
            // this.dialogueRef = this.dialog.open(templateRef, {
            //   panelClass: 'custom-modalboxSign'
            // });
          }
        } else {
          this.spinner = false;
          this.loaderService.hide();
          // this.dialogueRef = this.dialog.open(templateRef, {
          //   panelClass: 'custom-modalboxSign'
          // });
          return;
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
        // this.dialogueRef = this.dialog.open(templateRef, {
        //   panelClass: 'custom-modalboxSign'
        // });
        return;
      }
    });
  }

  addNewSignature() {
    this.signatureID = 0;
    this.hasSignature = !this.hasSignature;
  }

  signatureType(type: string) {
    this.signOpt = type;
  }

  onSelectSignImage(event, data: any, id: any) {
    // data=this.currentSign.data;
    // id=this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext.toUpperCase() != 'png'.toUpperCase() && ext.toUpperCase() != 'jpg'.toUpperCase() && ext.toUpperCase() != 'jpeg'.toUpperCase()) {
        alert('only image upload');
        return;
      }
      this.SignButtonEnable = true;
      // this.InitailButtonEnable=true;
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        this.filenameForSign = documentName;
        var base64String = reader.result;

        this.signOrInitialImageObj = [];
        this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        this.signatureBase64 = '';
        this.signName = '';
        // if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
        //   let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
        //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureBase64 = '';      
        //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureText = ''; 
        //   this.particiantJsonList = this.particiantJsonList;
        // }
      }
    }
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event   
  }

  drawComplete() {
    this.SignButtonEnable = true;
    this.DrawButtonEnable = true;
    this.InitailButtonEnable = true;
    // will be notified of szimek/signature_pad's onEnd event    
  }

  signOrInitialTextChanges(e: any) {
    if (this.signName !== '' && this.signName !== undefined) {
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      this.signatureBase64 = '';
      this.signOrInitialImageObj = [];
    } else {
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
    }
  }

  setSignInitialFontFamilyChange(e: any) {
    this.signInitialFontFamily = e;
  }

  selectedSignature(img: any) {
    this.signatureID = img.signatureID;
    this.signatureData = img;
    this.getAllSignatures.forEach(x => {
      x.isDefault = (x.signatureID == this.signatureID) ? true : false;
    })
    this.SignButtonEnable = true;
  }

  deleteSignature(signature) {
    if (this.participantEmailId == "" || this.participantEmailId == undefined || this.participantEmailId == null) {
      return;
    }
    const message = `Are you sure you want to delete this signature?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            signatureID: signature.signatureID,
            email: this.participantEmailId
          }
          this.settingsService.removeSignature(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.getAllSignatureInitialsAfterDelete();
              } else {

              }
            } else {

            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  getAllSignatureInitialsAfterDelete() {
    if (this.participantEmailId == "" || this.participantEmailId == undefined || this.participantEmailId == null) {
      return;
    }
    var rqModel = {
      email: this.participantEmailId,
    }
    this.spinner = true;
    this.settingsService.getSignaturesAndInitials(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner = false;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

          this.getAllSignatures = this.responseHolder.data.signatures;
          //  this.getAllInitials= this.responseHolder.data.initials;

          this.spinner = false;

          if (this.getAllSignatures.length > 0) {
            this.hasSignature = true;
            this.getAllSignatures.forEach(n => {
              n.signature = JSON.parse(n.signature);
            });
          } else {
            this.hasSignature = false;
          }

          // if(this.getAllInitials.length>0){
          //   this.getAllInitials.forEach(n => {              
          //     n.initial=JSON.parse(n.initial);
          //   });
          // } else{
          //   this.hasInitials = false;
          // }

          if (this.getAllSignatures.length == 5) {
            this.fiveSignaturesLimitReached = true;
          }
          else {
            this.fiveSignaturesLimitReached = false;
          }
          // if(this.getAllInitials.length==5){
          //   this.fiveInitialsLimitReached=true;
          // }
          // else{
          //   this.fiveSignaturesLimitReached=false;
          // }
        } else {
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    });
  }

  clearSignature() {
    this.SignButtonEnable = false;
    if (this.signaturePad != undefined) {
      this.signaturePad.clear();
    }
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined) {
      var context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.beginPath();
    }
  }

  // Make signature default

  addDefaultSignature() {
    if (this.participantEmailId == "" || this.participantEmailId == undefined || this.participantEmailId == null) {
      return;
    }
    if (this.signatureID > 0) {
      this.addSignatureAdopt();
    }
    var rqModel = {
      signatureID: this.signatureID,
      email: this.participantEmailId,
      isDefault: true
    }
    this.settingsService.addDefaultSignature(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

        }
      }
    });
    //this.dialogRef.close();
  }

  addSignatureAdopt() {
    //this.signatureID = img.signatureID;

    this.getAllSignatures.forEach(x => {
      x.isDefault = (x.signatureID == this.signatureID) ? true : false;
    })
    this.SignButtonEnable = true;

    //let data:any=this.ControlData;
    this.signatureID = this.signatureID;
    let sJson = this.signatureData.signature;

    if (sJson.type == 'Draw') {
      this.signatureBase64 = sJson.signatureBase64;
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = [];
    }
    if (sJson.type == 'Upload') {
      this.signatureBase64 = "";
      this.signName = "";
      this.signInitialFontFamily = "";
      this.signOrInitialImageObj = sJson.ImageData;
    }
    if (sJson.type == 'Type In') {
      this.signatureBase64 = "";
      this.signName = sJson.signatureText;
      this.signInitialFontFamily = sJson.signInitialFontFamily;
      this.signOrInitialImageObj = [];
    }
    var objs={
      from:'Adopt',
      sJson:sJson,
      signatureBase64:this.signatureBase64,
      signOrInitialImageObj:this.signOrInitialImageObj,
      signName:this.signName,
      signInitialFontFamily:this.signInitialFontFamily
    }
    this.dialogRef.close(objs);
    // return;

    //  if(this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    //    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
    //    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
    //    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
    //    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
    //    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
    //    var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);

    //    if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0){
    //      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
    //   }      
    //  this.particiantJsonList = this.particiantJsonList;


    //  // if(this.ControlData.find(x => x.img == data.img) && this.ControlData.find(x => x.img == data.img).fields.length > 0) {
    //  //   this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
    //  //   this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
    //  //   this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
    //  //   this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
    //  //   this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
    //  //   var field =  this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);

    //  //   if(this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0){
    //  //     this.ControlData.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
    //  //  }      
    //  //  this.ControlData = this.ControlData;



    //  //this.dialogueRef.close();
    // }
  }

  // =====  Add Signature =========//


  addSignature() {
    if (this.signatureID > 0) {
      this.addSignatureAdopt();
    } else {

      //let data:any=this.ControlData;
      let canvas = document.getElementsByTagName("canvas")[0];
      if (canvas != undefined) {
        this.signatureBase64 = canvas.toDataURL();
        this.signName = "";
        this.signOrInitialImageObj = [];
        var obj1={
          from:'Canvas',
          data: document.getElementsByTagName("canvas")[0]
        }
        this.dialogRef.close(obj1);
      }
      
      // if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
      //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
      //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
      //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
      //   var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);

      //   if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0){
      //      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
      //  }      
      //   this.particiantJsonList = this.particiantJsonList;

      var signatureBase;
      var isDefault;
      var type;
      var obj;
      if (this.signatureBase64 != "") {
        obj = {
          type: "Draw",
          signatureBase64: this.signatureBase64,
        }
        var objs1={
          from:'Adopt',       
          signatureBase64:this.signatureBase64,
          signOrInitialImageObj:[],
          signName:"",
          signInitialFontFamily:""
        }
        this.dialogRef.close(objs1);      
      }

      if (this.signOrInitialImageObj.length > 0) {
        obj = {
          type: "Upload",
          ImageData: this.signOrInitialImageObj,
        }

        var objs2={
          from:'Adopt',       
          signatureBase64:"",
          signOrInitialImageObj:this.signOrInitialImageObj,
          signName:"",
          signInitialFontFamily:""
        }
        this.dialogRef.close(objs2);    
      }
      if (this.signName != "") {
        obj = {
          type: "Type In",
          signatureText: this.signName,
          signInitialFontFamily: this.signInitialFontFamily
        }
        var objs3={
          from:'Adopt',       
          signatureBase64:"",
          signOrInitialImageObj:[],
          signName: this.signName,
          signInitialFontFamily: this.signInitialFontFamily
        }
        this.dialogRef.close(objs3);
      }
      // if(this.getAllSignatures.length==0){
      //   isDefault =true;
      // }
      // if(this.getAllSignatures.length>0){
      //   isDefault =false;
      // }
      if (this.participantEmailId == "" || this.participantEmailId == undefined || this.participantEmailId == null) {
        this.dialogRef.close();
        return;
      }
      var rqModel = {
        signature: JSON.stringify(obj),
        email: this.participantEmailId,
        isDefault: true
      }
      // return;
      this.settingsService.addSignature(rqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {

          }
        }
      });
    }
    //this.dialogRef.close();
  }


  close() {
    this.dialogRef.close();
  }

}
